import { Injectable } from "@angular/core";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Observable, from, map, tap } from "rxjs";
import { PhotoCapacitorUtils } from "./photo-capacitor.utils";
import { TranslateService } from "@ngx-translate/core";
import { PhotoTooHeavyError } from "@app/core/user/data/capacitor/photo-too-heavy.error";

@Injectable({
  providedIn: "root",
})
export class UploadPhotoCapacitor {
  constructor(private translateService: TranslateService) {}
  /** 
   Uses the browser to pick a photo from the device
   @returns the photo url taken
  **/
  execute(): Observable<string> {
    return from(
      Camera.getPhoto({
        source: CameraSource.Photos,
        resultType: CameraResultType.Base64,
        height: PhotoCapacitorUtils.UPLOAD_IMAGE_HEIGHT_PX,
        width: PhotoCapacitorUtils.UPLOAD_IMAGE_WIDTH_PX,
      })
    ).pipe(
      map((image) =>
        PhotoCapacitorUtils.base64DataToBase64WithFormat(
          image.base64String ?? "",
          image.format
        )
      ),
      tap((image) => {
        if (!PhotoCapacitorUtils.isLessThanMaxSize(image)) {
          throw new PhotoTooHeavyError();
        }
      })
    );
  }
}
